import axiosHandler from "../../Intersepter/axiosInstance";

// Function to fetch jackpot numbers
export const getJackpotNumber = async () => {
    try {
      const response = await axiosHandler.get(`/wallet/send-jackpot-number`);
      return response;
    } catch (error) {
      console.error("Error fetching jackpot number:", error);
      throw error;
    }
  };

// Example: Usage of getWinners function
export const getWinners = async () => {
  try {
    const response = await axiosHandler.get('/user/winners');
    return response;
  } catch (error) {
    console.error("Error fetching winners:", error);
    throw error;
  }
};
